import {darkTheme} from '../config/themes';

/**
 * Whether the POS selling screens must render in the dark navy theme.
 *
 * @param {object} args
 * @param {boolean} args.isPhoneUi Phone-first POS UI active (narrow screen, not Classic).
 * @param {boolean} args.posDarkMode "Dark POS screens" preference.
 * @returns {boolean}
 */
export const shouldForcePosDark = ({isPhoneUi, posDarkMode} = {}) => Boolean(isPhoneUi && posDarkMode);

/**
 * Theme-context value of a forced-dark POS subtree: the app value with the dark
 * palette swapped in. `appIsDark` keeps the real app theme so screens can restore
 * app-level chrome (status bar) when they leave.
 *
 * @param {object} [parent] Value of the app ThemeContext.
 * @returns {object}
 */
export const buildForcedDarkThemeValue = (parent = {}) => ({
    ...parent,
    theme: darkTheme,
    isDark: true,
    appIsDark: Boolean(parent?.isDark),
});
